import { Participation, Session } from '@app/api';
import { getIconFromFormat, IconChip, IconChipsProps } from '@app/core';
import { useTranslation } from 'react-i18next';

type Props = {
  focus?: boolean;
  participation?: Participation;
  session?: Session;
};

export const SessionFormatChip = ({
  participation,
  session: sessionProps,
  focus,
  ...rest
}: Props & IconChipsProps) => {
  const session = participation?.session || sessionProps;
  const { t } = useTranslation();

  const format = participation?.format || session?.format;
  if (!format) {
    return null;
  }
  return (
    <IconChip
      icon={getIconFromFormat(format)}
      label={t(`sessionChips.formats.${format}`, { ns: 'common' })}
      color="purple"
      {...rest}
    />
  );
};
